import { FC } from 'react';
import type { CustomChartTextSize, CustomChartTextSummaryPayload } from '@/entities/dashboards';
import { cn } from '@/shared/lib';
import { RichTextContent } from '@/shared/ui';
import { ChartCardShell } from '../ChartCardShell';
import { chartTextSizeClass } from '../chartTextSize';

type Props = {
  title: string;
  payload: CustomChartTextSummaryPayload;
  /** Размер текста результата; не задан — текст показан размером по умолчанию */
  textSize?: CustomChartTextSize;
};

/**
 * Текстовая сводка: связный текст, составленный по отобранным правилом агрегатам.
 *
 * Текст показывается ровно так, как набран: перечень величин остаётся перечнем строк, а знаки
 * внутри подставленных значений остаются знаками.
 */
export const TextSummaryChartView: FC<Props> = ({ title, payload, textSize }) => (
  <ChartCardShell title={title}>
    <RichTextContent html={payload.markdown} className={cn('w-full', chartTextSizeClass(textSize))} />
  </ChartCardShell>
);
